// ProfilePage.jsx — the sidebar's "Profile" link (/profile). Coordinator self-service:
// shows who is signed in and lets them change their own password.
import React from 'react';
import apiConfig from '../../../config/apiConfig';
import { getToken } from '../../../utils/auth';
import { ChangePasswordForm } from './ChangePasswordForm';
import { changePasswordRequest } from './changePasswordRequest';
import { storeReissuedToken } from './reissuedSession';

const cardStyle = {
  maxWidth: 560,
  padding: '1.5rem',
  borderRadius: 12,
  border: '1px solid var(--ra-glass-border)',
  background: 'rgba(255,255,255,0.03)',
  marginBottom: '1.5rem',
};

export default function ProfilePage() {
  const email = localStorage.getItem('userEmail') || sessionStorage.getItem('userEmail') || '';
  const companyName = localStorage.getItem('companyName') || '';

  // A password change revokes every earlier session, this one included. Store the token the server
  // re-issues, or the next request is refused and the user is signed out by their own change.
  const changePassword = async (current, next) => {
    const previous = getToken();
    const result = await changePasswordRequest(apiConfig.getBaseUrl(), previous, current, next);
    if (result.success && result.token) storeReissuedToken(previous, result.token);
    return result;
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>Profile</h1>

      <section style={cardStyle} aria-labelledby="profile-account">
        <h2 id="profile-account" style={{ fontSize: '1.1rem', marginTop: 0 }}>Account</h2>
        <div style={{ color: 'var(--ra-text-secondary)', fontSize: '0.9rem' }}>
          <div>Signed in as <strong>{email || 'unknown'}</strong></div>
          {companyName && <div style={{ marginTop: '0.25rem' }}>Company: {companyName}</div>}
        </div>
      </section>

      <section style={cardStyle} aria-labelledby="profile-password">
        <h2 id="profile-password" style={{ fontSize: '1.1rem', marginTop: 0 }}>Change password</h2>
        <ChangePasswordForm changePassword={changePassword} />
      </section>
    </div>
  );
}
